import React from 'react'
import { getLandingContent } from 'services'
import { LandingContent } from 'types'

type Props = {
  content: LandingContent | null
  error: string | null
}

export const DataLandingContext = React.createContext({} as Props)

export const DataLandingProvider = ({ children }: { children: React.ReactNode }) => {
  const [content, setContent] = React.useState<LandingContent | null>(null)
  const [error, setError] = React.useState<string | null>(null)
  const [isLoading, setIsLoading] = React.useState(false)
  const hasLoadedRef = React.useRef(false)

  const fetchLandingContent = async () => {
    if (isLoading || hasLoadedRef.current) {
      return
    }

    try {
      hasLoadedRef.current = true
      setIsLoading(true)
      setError(null)
      const data = await getLandingContent()
      setContent(data)
    } catch (err) {
      setError('Error al cargar el contenido')
      console.error('Error fetching landing content:', err)
      hasLoadedRef.current = false
    } finally {
      setIsLoading(false)
    }
  }

  React.useEffect(() => {
    fetchLandingContent()
  }, [])

  React.useEffect(() => {
    const startPolling = () => {
      return setInterval(() => {
        fetchLandingContent()
      }, 5000)
    }

    const intervalId = startPolling()

    return () => clearInterval(intervalId)
  }, [])

  return (
    <DataLandingContext.Provider
      value={{
        content,
        error,
      }}
    >
      {children}
    </DataLandingContext.Provider>
  )
}

export default DataLandingProvider
